import * as Sentry from "@sentry/sveltekit";
import type { HandleClientError } from "@sveltejs/kit";

import { isIgnoredConsoleLog } from "$lib/core/console-log-filter";
import { initDatadogObservability } from "$lib/core/datadog-rum";
import { generateErrorId } from "$lib/core/error";

Sentry.init({
  dsn: "https://d75f7cb747cd4fe8ac03973ae3d39fec@o1108641.ingest.sentry.io/6688362",
  ignoreErrors: [
    /Failed to fetch dynamically imported module/i,
    /Unable to preload CSS/i,
  ],
  integrations: [
    Sentry.consoleLoggingIntegration({
      levels: ["log", "info", "warn", "error"],
    }),
  ],
  enableLogs: true,
  beforeSendLog: (log) => {
    if (isIgnoredConsoleLog(log.message)) {
      return null;
    }
    return log;
  },
  environment: import.meta.env.MODE,
  tunnel: "/sentry-tunnel",
});

initDatadogObservability();

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError: HandleClientError = async ({
  error,
  event,
  status,
  message,
}) => {
  const errorId = generateErrorId();

  if (status === 404) {
    return {
      message: "Not found",
      errorId,
    };
  }

  Sentry.captureException(error, {
    tags: { error_id: errorId },
    extra: { event, errorId, status, route: event.route.id ?? undefined },
  });

  console.error(`Uncaught ${status} error (${errorId}): ${message}`);
  console.error(error);

  return {
    message,
    errorId,
  };
};
